// Token i identyfikator aplikacji dla zapytań do API panelu (Cloud Functions).
//
// Wyszukiwarka, endpointy Elastica i zarządzanie użytkownikami wymagają teraz checkAccess
// (wcześniej każdy, kto znał adres API, mógł je wywołać bez logowania). Nagłówki dokładamy
// wyłącznie do adresu naszego API - nie do obcych domen, jak robił wyłączony
// authAxiosPlugin w store (x-app-id u obcych psuł preflight CORS).
import axios from 'axios';
import { auth } from '@/firebase/gfbconf';

// Ta sama wartość, której pilnuje checkAccess (WEB_APP_ID w funkcjach) - jak w subiektApi.js.
const APP_ID = 'janart_6692046951778248';

export function installApiAuth(store) {
  axios.interceptors.request.use(async (config) => {
    const url = (config.baseURL || '') + (config.url || '');
    const apiLink = store.state.apiLink;
    if (!apiLink || !url.startsWith(apiLink)) return config;

    config.headers = config.headers || {};
    if (!config.headers['x-app-id']) config.headers['x-app-id'] = APP_ID;
    // Bez sesji (np. publiczna strona potwierdzenia dostawy) zapytanie idzie bez tokenu -
    // tamte endpointy go nie wymagają.
    if (!config.headers.Authorization && auth.currentUser) {
      try {
        config.headers.Authorization = `Bearer ${await auth.currentUser.getIdToken()}`;
      } catch (error) {
        console.log('Nie udało się pobrać tokenu:', error);
      }
    }
    return config;
  });
}
